import React from 'react';

function Contact(props) {
    return (
        <>
            <div
                className={"bg-paynes_gray-300 p-2 text-black cursor-black rounded-b rounded-tr overflow-y-auto shadow-xl"}>
                <div className={"bg-dutch_white-300 text-lg p-4 mx-auto rounded shadow w-fit"}>

                <div
                    className="p-6 bg-gray-100 text-gray-800 rounded-lg shadow-md max-w-3xl mx-auto text-left mb-4">
                    <h2 className="text-xl font-bold mb-4 text-center">Contact</h2>

                    <div className={"text-left col-span-5 col-start-2 h-full flex flex-col mb-2"}>
                        We are currently in the process of developing an internal solution for communication. If you'd like to get in
                        touch about Brainmeter to either provide feedback or discuss implementation at your school, please send an
                        email to justinlcochran@brainmeter.org.
                    </div>
                </div>
                </div>
            </div>
        </>
    );
}

export default Contact;